<template>
  <a-row>
    <a-row class="content-title" type="flex">
      <h2>Настройки</h2>
      <a-button
        type="primary"
        style="margin-left: auto"
        :disabled="pending"
        @click="submit"
      >
        <a-icon type="save" />Сохранить
      </a-button>
    </a-row>

    <!--  -->
    <!-- meta -->
    <!--  -->
    <!-- meta keywords -->
    <a-row class="mb-2">
      <a-col class="pt-1 pr-8p text-right" :span="6">
        Meta Ключевые слова <br />(keywords):
      </a-col>

      <a-col :span="18">
        <a-textarea v-model="form.meta_keys" :auto-size="{ minRows: 3 }" />
      </a-col>
    </a-row>

    <!-- meta description -->
    <a-row class="mb-2">
      <a-col class="pt-1 pr-8p text-right" :span="6">
        Meta Описание <br />(description):
      </a-col>

      <a-col :span="18">
        <a-textarea v-model="form.meta_desc" :auto-size="{ minRows: 3 }" />
      </a-col>
    </a-row>

    <!-- Bot token -->
    <a-row class="mb-2">
      <a-col class="pt-1 pr-8p text-right" :span="6"> Ключ токена бота: </a-col>

      <a-col :span="18">
        <a-textarea v-model="form.bot_token" :auto-size="{ minRows: 3 }" />
      </a-col>
    </a-row>

    <!-- Bot chat id -->
    <a-row class="mb-2">
      <a-col class="pt-1 pr-8p text-right" :span="6"> Чат айди бота: </a-col>

      <a-col :span="18">
        <a-textarea
          v-model.number="form.bot_chat_id"
          :auto-size="{ minRows: 3 }"
        />
      </a-col>
    </a-row>
  </a-row>
</template>

<script>
import { mapActions } from "vuex"
export default {
  data() {
    return {
      form: {
        meta_keys: "",
        meta_desc: "",

        bot_token: "",
        bot_chat_id: null
      },
      pending: false
    }
  },

  async mounted() {
    try {
      const r = await this.fetchSettings()
      if (r) {
        this.form = r
      }
    } catch (error) {
      console.error(error)
    }
  },

  methods: {
    ...mapActions("settings", ["fetchSettings", "submitSettings"]),
    async submit() {
      try {
        this.pending = true
        await this.submitSettings(this.form)
        this.$message.success("Настройки сохранены")
      } catch (error) {
        console.error(error)
      }
      this.pending = false
    }
  }
}
</script>
